// extracted by css-extract-rspack-plugin
export default {"categories":"LmK2F","link":"ceEnB","icon":"CnSoz"};